import { IoLogOutOutline, IoNewspaperOutline } from "react-icons/io5";
import useUser from "../../App/useUser";
import useToken from "../../App/useToken";
import axios from "axios";
import { useState, useRef, useEffect } from "react";

const UserInfo = () => {
    const { user, setUser } = useUser();
    const { token, setToken } = useToken();
    const [dropdownActive, setDropdownActive] = useState(false);
    const loginInfoRef = useRef();

    useEffect(() => {
        document.addEventListener("mousedown", handleClickDropdownOutside);
        return () => document.removeEventListener("mousedown", handleClickDropdownOutside);
    });

    const handleProfile = () => {
        window.location.href = process.env.REACT_APP_HOME_URL + "/profile";
    };

    const handleLogout = () => {
        axios
            .get(process.env.REACT_APP_API_URL + "/auth/logout", {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${token.token}`,
                },
            })
            .then((response) => {
                if (response !== undefined && response.status === 201) {
                    window.location.href = process.env.REACT_APP_HOME_URL;
                    setToken(null);
                    setUser(null);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleDropdown = () => {
        setDropdownActive(!dropdownActive);
    };

    const handleClickDropdownOutside = (e) => {
        if (!loginInfoRef.current.contains(e.target)) {
            setDropdownActive(false);
        }
    };

    return (
        <div ref={loginInfoRef} className={dropdownActive ? "login-information show-dropdown" : "login-information"} onClick={handleDropdown}>
            <span className="user-profile">
                <span className="user-name">{user.name}</span>
                <span className="user-designation">{user.role.replaceAll("_", " ")}</span>
            </span>
            <div className="user-image">
                <img className="image-rounded" src={user.profile_image ? process.env.REACT_APP_HOME_URL + "/" + user.profile_image : process.env.REACT_APP_HOME_URL + "/images/blank-profile.png"} alt="Profile" />
            </div>
            <div className="login-actions">
                <span className="profile" onClick={handleProfile}>
                    <IoNewspaperOutline /> Profile
                </span>
                <span className="logout" onClick={handleLogout}>
                    <IoLogOutOutline /> Logout
                </span>
            </div>
        </div>
    );
};

export default UserInfo;
